import { DomainUpsertLoadingList } from "@/components/domain";
import { useGetTourAgency, useUpdateTourAgency } from "@/hooks/tour-agencies";
import { CreateTourAgency, TourAgency, TourAgencyDomain } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
)({
  component: RouteComponent,
  validateSearch: z.object({
    domain: z.enum(["agency", "tour"]),
  }),
});

function RouteComponent() {
  const { id, taId } = Route.useParams();
  const { domain } = Route.useSearch();
  const { data: tourAgency, isLoading } = useGetTourAgency(domain, taId);
  if (isLoading || !tourAgency) return <DomainUpsertLoadingList />;
  return <Edit domain={domain} id={id} model={tourAgency} />;
}

function Edit({
  model,
  domain,
  id,
}: {
  model: TourAgency;
  id: string;
  domain: TourAgencyDomain;
}) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateTourAgency(domain, id, {
    onSuccess: () => {
      navigate({
        to: "/tour-agencies/$id",
        params: { id },
        search: { domain },
      });
    },
  });

  const update = async (tourAgency: CreateTourAgency) => {
    await mutateAsync({ id: model.id, ...tourAgency });
  };
  return <Form model={model} onUpsert={update} domain={domain} domainId={id} />;
}
